module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1271.57ff23c0.png";